<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>前方是霓虹闪烁却暗藏杀机的街巷，《觉醒守卫之战》是否能迎来共存的和平？踏入 “V” 组织笼罩的禁区，探寻未竟的传说：安定区的余温、奎库利亚的嘶吼、流岛的硝烟，或许无人能全身而退，或许无人能打破对立，你会是那位​掌控独眼之王之力的强者，改写命运的平衡吗？</p>
    <!-- <pre> -->
    <h2 class="title" style="margin-bottom: 0px">游戏特色</h2>
    <div class="content">
      <div class="content-item">
        <h4>【原动漫 名场面】​​</h4>
        全角色剧情在掌间完整重现，1:1 高精度 3D 建模复刻经典名场面：惊心动魄的 20 区突袭、震撼人心的枭战终局、惊天动地的龙战爆发。全景特效逼真还原赫子与库因克的激烈碰撞，金木研蜈蚣赫子的致命绞杀，有马贵将 IXA 光刃的凌厉锋芒，沉浸式体验东京暗黑世界的生存之战！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【快节奏 挖彩蛋】​​</h4>
        从安定区静谧后巷到奎库利亚阴森地牢，从月山家奢华宅邸到流岛残酷战场，再到「V」组织戒备森严的总部。每个副本都隐藏着独特彩蛋 —— 古董店地下室的神秘线索、库因克锻造的不传之秘，等你探索。战斗节奏紧张刺激，攻守策略瞬息万变，每一步都可能是生与死的抉择！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【多形态 高颜值】​​</h4>
        根据成长经历精心设计皮肤服装，白金木冷峻霸气的战斗装束、董香温婉动人的咖啡店便服、有马贵将英姿挺拔的制服、呗充满神秘感的戏服，暗黑酷飒、温柔治愈、精英飒爽、邪魅神秘等多种风格一网打尽，视觉盛宴不容错过！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【登录送 高倍率】​​</h4>
        新服直接开启狂欢模式！登录即送SSS赫者，开局千抽助力，轻松组建强力阵容。无论是喰种军团还是 CCG 小队，任你自由搭配。赫子系统支持无损转换，告别废卡烦恼，随时根据战局调整策略 —— 用速度型角色制霸巷战，以范围型技能压制群体，打造专属于你的东京生存小队！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
